export const tabs = {
    init: () => {
        const $ = jQuery;

        const tabs_wrapper = $('.tabs-wrapper');

        if (tabs_wrapper.length === 0) {
            return false;
        }

        tabs_wrapper.each((i, tab_wrapper) => {
            const triggers_wrapper = $(tab_wrapper).find('.tabs-trigger-wrapper');
            const triggers = $(triggers_wrapper).find('.tabs--trigger');
            const prev_arrow = $(tab_wrapper).find('.prev-arrow');
            const next_arrow = $(tab_wrapper).find('.next-arrow');

            triggers.each((j, trigger) => {
                $(trigger).on('click', () => {
                    const tab_id = $(trigger).data('tab');

                    $(triggers).removeClass('active');
                    
                    const tabs = $(tab_wrapper).find('.tabs--content');

                    tabs.removeClass('fade');
                    setTimeout(() => {
                        tabs.removeClass('active');
                        tabs.filter('[data-tab="' + tab_id + '"]').addClass('active');
                        setTimeout(() => {
                            tabs.filter('[data-tab="' + tab_id + '"]').addClass('fade');
                            $(trigger).addClass('active');
                        }, 100);
                    }, 500)
                })
            });

            $(prev_arrow).on('click', () => {
                const scrollLeft = triggers_wrapper[0].scrollLeft;
                let width = 0;

                if (scrollLeft === 0) {
                    return;
                }

                $(triggers).each((i, trigger) => {
                    width += trigger.offsetWidth;
                });
                
                $(triggers).each((i) => {
                    const j = (triggers.length - 1) - i;
                    const triggerWidth = triggers[j].offsetWidth;
                    width = width - triggerWidth;

                    if (width < scrollLeft) {
                        triggers_wrapper[0].scrollLeft -= (scrollLeft - width);
                        return false;
                    }
                });
            });

            $(next_arrow).on('click', () => {
                const wrapperWidth = triggers_wrapper[0].offsetWidth;
                const scrollLeft = triggers_wrapper[0].scrollLeft;
                let width = scrollLeft * -1;

                triggers.each((i, trigger) => {
                    width += trigger.offsetWidth;

                    if (width > wrapperWidth) {
                        triggers_wrapper[0].scrollLeft += (width - wrapperWidth);
                        return false;
                    }
                });
            });
        });

        $(window).on('resize', () => {
            clearTimeout(window.resizeFinished);
            
            window.resizeFinished = setTimeout(function() {
                tabs_wrapper.each((i, tab_wrapper) => {
                    const triggers_wrapper = $(tab_wrapper).find('.tabs-trigger-wrapper');
                    const children = $(triggers_wrapper).find('.tabs--trigger');

                    const parent_width = $(triggers_wrapper).innerWidth();
                    let child_width = 0;

                    $(children).each((i, v) => {
                        child_width += $(v).innerWidth();
                    });

                    if ( child_width > parent_width ) {
                        $(triggers_wrapper).removeClass('no-arrows');
                    } else {
                        $(triggers_wrapper).addClass('no-arrows');
                    }
                });
            }, 250);
        });
    }
}